import {get} from 'lodash';
interface Person {
  firstName: string;
  lastName: string;
  name: string;
}
interface PersonFullNameProps {
  item?: Person | null;
}

export const PersonFullName = ({item}: PersonFullNameProps): string => {
  const firstName = get(item, 'firstName', '');
  const lastName = get(item, 'lastName', '');
  const name = get(item, 'name', '');

  if (name) {
    return name;
  } else {
    return `${firstName} ${lastName}`;
  }
};

export default PersonFullName;
